import { ID_CODE_REGEX, EMAIL_REGEX } from 'utils/constants/formConstants';

export const userFormFields = {
  firstName: {
    label: 'datagate.external.users.firstName',
    defaultValue: '',
    rules: {
      required: 'datagate.external.users.firstName.requiredMessage',
    },
    id: 'userFirstNameInput',
  },
  lastName: {
    label: 'datagate.external.users.lastName',
    defaultValue: '',
    rules: {
      required: 'datagate.external.users.lastName.requiredMessage',
    },
    id: 'userLastNameInput',
  },
  idCode: {
    label: 'datagate.external.users.idCode',
    defaultValue: '',
    rules: {
      required: 'datagate.external.users.idCode.requiredMessage',
      minLength: {
        value: 11,
        message: 'datagate.external.users.idCode.lengthMessage',
      },
      maxLength: {
        value: 11,
        message: 'datagate.external.users.idCode.lengthMessage',
      },
      pattern: {
        value: ID_CODE_REGEX,
        message: 'datagate.external.users.idCode.patternMessage',
      },
    },
    id: 'userIdCodeInput',
  },
  username: {
    label: 'datagate.external.users.username',
    defaultValue: '',
    id: 'userUsernameInput',
  },
  notificationEmail: {
    label: 'datagate.external.users.notificationEmail',
    defaultValue: '',
    rules: {
      required: 'datagate.external.users.notificationEmail.requiredMessage',
      pattern: {
        value: EMAIL_REGEX,
        message: 'datagate.external.users.notificationEmail.patternMessage',
      },
    },
    id: 'userNotificationEmailInput',
  }
};

export const getUserFormFieldProps = (fieldName, control, errors) => {
  const fieldConfig = userFormFields[fieldName];

  return {
    name: fieldName,
    ...fieldConfig,
    control,
    color: errors?.[fieldName] ? 'danger' : 'primary',
  };
};
